'use client'

import { useAbTest } from '@marketplace-web/shared/ab-tests'
import { useBreakpoint } from '@marketplace-web/shared/breakpoints'
import { useFeatureSwitch } from '@marketplace-web/shared/feature-switches'
import { useSession } from '@marketplace-web/shared/session'
import { useTranslate } from '@marketplace-web/shared/i18n'

import VacationNotification from '../VacationNotification'

const ClientVacationNotification = () => {
  const { user } = useSession()
  const isPortalClosed = useFeatureSwitch('portal_closure_stage_3')

  const translate = useTranslate('vacation_notification')
  const breakpoints = useBreakpoint()

  const profileReworkAbTest = useAbTest('profile_wardrobe_web_rework')
  const isProfileReworkTestOn = profileReworkAbTest?.variant === 'on' && !breakpoints.portables

  if (isPortalClosed) return null
  if (!user?.is_on_holiday) return null

  return (
    <VacationNotification
      userId={user.id}
      className={isProfileReworkTestOn ? 'u-margin-horizontal-large' : undefined}
      titleLabel={translate('title')}
      actionLabel={translate('actions.end')}
    />
  )
}

export default ClientVacationNotification
